module.exports = __webpack_public_path__ + "img/main.aacaf0e3.svg";